import { render, staticRenderFns } from "./LightboxCarousel.vue?vue&type=template&id=70735a81&scoped=true"
import script from "./LightboxCarousel.vue?vue&type=script&lang=js"
export * from "./LightboxCarousel.vue?vue&type=script&lang=js"
import style0 from "./LightboxCarousel.vue?vue&type=style&index=0&id=70735a81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70735a81",
  null
  
)

export default component.exports